import { Component, OnInit } from '@angular/core';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { User } from '../../_models/user';

@Component({
  selector: 'app-admin-fulfillment-pricing',
  templateUrl: './admin-fulfillment-pricing.component.html',
  styleUrls: ['./admin-fulfillment-pricing.component.scss'],
})
export class AdminFulfillmentPricingComponent implements OnInit {
  pricingType: any = 'CUSTOMER';
  accountOwners: any;
  accountOwner: any;
  servicesList: any;
  services: any;
  constructor(private alertService: AlertService, private g: Globals, private http: HttpClient, public user: User, private api: ApiIntegration) {
    this.g.loaderDisplay = "display";
    this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.accountOwners = data.getAccountOwnersResponses;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }
  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }
  getOrgList() {
    this.g.loaderDisplay = "display";
    this.api.getFulfillmentPrices().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.services = data.getFulfillmentPricesResponses;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = ""
    });
  }

  getList() {
    if (this.accountOwner) {
      this.g.loaderDisplay = "display";
      this.api.getFulfillmentPrices().subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.servicesList = data.getFulfillmentPricesResponses;
      }, err => {
        this.alertService.error('Error', err);
        this.g.loaderDisplay = "";
      });
    }
  }
  ngOnInit() { }
  clear() {
    this.accountOwner = '';
    for (let sl of this.servicesList) {
      sl.pricing = '';
    }
    for (let sl of this.services) {
      sl.pricing = '';
    }
  }
  fulfillmentSave() {
    let aoPrice;
    aoPrice = {
      "accountOwnerId": this.accountOwner,
      "organizationId": this.user.organizationId,
      "createFulfillmentPriceRequests": this.servicesList
    };
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createFulfillmentPriceForAO', aoPrice,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Pricing', 'Updated Successfully');
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  orgSave() {
    let orgPrice;
    orgPrice = {
      "accountOwnerId": this.accountOwner,
      "organizationId": this.user.organizationId,
      "createFulfillmentPriceRequests": this.services
    };
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateFulfillmentPriceForOrg', orgPrice,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Pricing', 'Updated Successfully');
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
